import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField, Button, styled, Typography } from '@mui/material';
import BaseCodeSelectbox from '../common/form/selectbox/BaseCodeSelectbox';
import TextMaskBusinessNo from '../common/form/TextMaskBusinessNo';
import { FieldArray, Form, Formik } from "formik";
import ParMultiFileFormOne from '../../components/partnermng/files/ParMultiFileFormOne';

const FormLabel = styled(Box)(({ theme }) => ({
  //backgroundColor:'#ddd',
  ...theme.typography.subtitle2,
  borderRight: (theme) => `1px solid ${theme.palette.divider}`,
  textAlign: 'center',
}));

const PartnerForm = ({ formik, type }) => {
  useEffect(() => {
    const targetTyp = formik.values.partnerTyp;
    const fields = ['president', 'regNumber', 'partnerPhone', 'accountOpenDate', 'partnerAddr'];
    const today = new Date().toISOString().split('T')[0];
    if(type==='add') {
      if (targetTyp === '고객사') {
        fields.forEach(field => {
          const val = field === 'accountOpenDate' 
          ? today 
          : field === 'regNumber' 
            ? '000-00-00000' 
            : field === 'partnerPhone' 
              ? '000-0000-0000' 
              : '없음';
          formik.setFieldValue(field, val, false);
          formik.setFieldTouched(field, false, false);
        });
        formik.setFieldTouched('partnerNm', false, false);
        formik.setFieldTouched('incTyp', false, false);
      } else {
        fields.forEach(field => {
          formik.setFieldValue(field, '', false);
          formik.setFieldTouched(field, false, false);
        });
        formik.setFieldTouched('partnerNm', false, false);
        formik.setFieldTouched('incTyp', false, false);
        formik.setFieldValue('accountOpenDate', today, false);
        formik.setFieldTouched('accountOpenDate', false, false);
      }
    }
  }, [formik.values.partnerTyp]);
  const FormLabel = styled(Box)(({ theme }) => ({
    ...theme.typography.subtitle2,
    textAlign: 'left',   // 1. 좌측 정렬로 변경
    paddingLeft: '12px', // 2. 좌측 여백 추가 (스페이싱 조절)
    display: 'flex',     // 3. (선택사항) 수직 중앙 정렬을 위해 추가
    alignItems: 'center',
    height: '100%',      // 부모 높이에 맞춤
  }));
  return (
    <div>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 1,
          px: 2,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={1}>
            <FormLabel
               sx={{ 
                mr: 2 // 왼쪽 여백이 필요할 경우
              }}
            >거래처 종류</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <BaseCodeSelectbox
              formik={formik}
              variant="outlined"
              required={true}
              fullWidth
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'PARTNER',
                slcCd: 'PARTNER_TYP',
                useYn: 'Y',
              }}
              name="partnerTyp"
              size="small"              
            />
          </Grid>
          <Grid item xs={1}>
            <FormLabel>산업체 유형</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <BaseCodeSelectbox
              formik={formik}
              variant="outlined"
              required={true}
              fullWidth
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'FORCAST',
                slcCd: 'INC_TYP',
                useYn: 'Y',
              }}
              name="incTyp"
              size="small"
            />
          </Grid>
          <Grid item xs={1}>
            <FormLabel>거래처명</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="partnerNm"
              name="partnerNm"
              value={formik.values.partnerNm}
              onChange={formik.handleChange}
              error={
                formik.touched.partnerNm && Boolean(formik.errors.partnerNm)
              }
              helperText={formik.touched.partnerNm && formik.errors.partnerNm}
            />
          </Grid>
          <Grid item xs={1}>
            <FormLabel>대표자명</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="president"
              name="president"
              value={formik.values.president}
              onChange={formik.handleChange}
              error={
                formik.touched.president && Boolean(formik.errors.president)
              }
              helperText={formik.touched.president && formik.errors.president}
            />
          </Grid>
        </Grid>        
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={1}>
            <FormLabel
               sx={{ 
                mr: 2 // 왼쪽 여백이 필요할 경우
              }}
            >사업자번호</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="regNumber"
              name="regNumber"
              value={formik.values.regNumber}
              onChange={(event) => {
                formik.setFieldValue('regNumber', event.target.value);
              }}
              error={
                formik.touched.regNumber && Boolean(formik.errors.regNumber)
              }
              helperText={formik.touched.regNumber && formik.errors.regNumber}
              InputProps={{
                inputComponent: TextMaskBusinessNo,
              }}
            />
          </Grid>
          <Grid item xs={1}>
            <FormLabel>연락처</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="partnerPhone"
              name="partnerPhone"
              value={formik.values.partnerPhone}
              onChange={formik.handleChange}
              error={
                formik.touched.partnerPhone &&
                Boolean(formik.errors.partnerPhone)
              }
              helperText={
                formik.touched.partnerPhone && formik.errors.partnerPhone
              }
            />
          </Grid>
          <Grid item xs={1}>
            <FormLabel>주소</FormLabel>
          </Grid>
          <Grid item xs={5}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="partnerAddr"
              name="partnerAddr"
              value={formik.values.partnerAddr}
              onChange={formik.handleChange}
              error={
                formik.touched.partnerAddr && Boolean(formik.errors.partnerAddr)
              }
              helperText={
                formik.touched.partnerAddr && formik.errors.partnerAddr
              }
            />
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={1}>
            <FormLabel
               sx={{ 
                mr: 2 // 왼쪽 여백이 필요할 경우
              }}
            >거래게시일</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <TextField
              fullWidth size="small" variant="outlined" type="date"
              id="accountOpenDate" name="accountOpenDate"
              InputLabelProps={{ shrink: true }}
              value={formik.values.accountOpenDate}
              onChange={formik.handleChange}
              error={formik.touched.accountOpenDate && Boolean(formik.errors.accountOpenDate)}
              helperText={formik.touched.accountOpenDate && formik.errors.accountOpenDate}
            />
          </Grid>
          <Grid item xs={1}>
            <FormLabel>계산서 접수 이메일</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="taxEmail"
              name="taxEmail"
              value={formik.values.taxEmail}
              onChange={formik.handleChange}
              error={
                formik.touched.taxEmail && Boolean(formik.errors.taxEmail)
              }
              helperText={formik.touched.taxEmail && formik.errors.taxEmail} 
            />
          </Grid>
          <Grid item xs={1}>
            <FormLabel>은행명</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="bankName"
              name="bankName"
              value={formik.values.bankName}
              onChange={formik.handleChange}
              error={
                formik.touched.bankName && Boolean(formik.errors.bankName)
              }
              helperText={formik.touched.bankName && formik.errors.bankName} 
            />
          </Grid>
          <Grid item xs={1}>
            <FormLabel>계좌번호</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="accountNumber"
              name="accountNumber"
              value={formik.values.accountNumber}
              onChange={formik.handleChange}
              error={
                formik.touched.accountNumber && Boolean(formik.errors.accountNumber)
              }
              helperText={formik.touched.accountNumber && formik.errors.accountNumber}
            />
          </Grid>
        </Grid>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={1}
            sx={{
              py: 2,
              borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Grid item xs={1} sx={{ mt: 1 }}>
              <FormLabel>사업자 등록증</FormLabel>
            </Grid>
            <Grid item xs={5}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <ParMultiFileFormOne formik={formik} name={'companyCBR'} />
                <Typography sx={{ fontSize: '0.8rem', color: 'error.main', pl: 0.5 }}>
                  ※ 파일명은 예제 형식에 맞춰주세요. 예) : 에이치씨인포_사업자등록증_202260101
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={1} sx={{ mt: 1 }}>
              <FormLabel>통장 사본</FormLabel>
            </Grid>
            <Grid item xs={5}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <ParMultiFileFormOne formik={formik} name={'copyBankBook'} />
                <Typography sx={{ fontSize: '0.8rem', color: 'error.main', pl: 0.5 }}>
                  ※ 파일명은 예제 형식에 맞춰주세요. 예) : 에이치씨인포_통장사본_202260101
                </Typography>
              </Box>
            </Grid>
          </Grid>

        {/*
        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
        <Grid item xs={1}>
            <FormLabel>주요품목</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="mainItemDesc"
              name="mainItemDesc"
              value={formik.values.mainItemDesc}
              onChange={formik.handleChange}
              error={
                formik.touched.mainItemDesc && Boolean(formik.errors.mainItemDesc)
              }
              helperText={formik.touched.mainItemDesc && formik.errors.mainItemDesc}
            />
          </Grid>
          <Grid item xs={1}>
            <FormLabel>업태</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="businessStatus"
              name="businessStatus"
              value={formik.values.businessStatus}
              onChange={formik.handleChange}
              error={
                formik.touched.businessStatus && Boolean(formik.errors.businessStatus)
              }
              helperText={formik.touched.businessStatus && formik.errors.businessStatus} 
            />
          </Grid>
          <Grid item xs={1}>
            <FormLabel>종목</FormLabel>
          </Grid>
          <Grid item xs={2}>
            <TextField
              size="small"
              variant="outlined"
              required
              fullWidth
              id="businessTyp"
              name="businessTyp"
              value={formik.values.businessTyp}
              onChange={formik.handleChange}
              error={
                formik.touched.businessTyp && Boolean(formik.errors.businessTyp)
              }
              helperText={formik.touched.businessTyp && formik.errors.businessTyp}
            />
          </Grid>
        </Grid>
        */}

        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{
            py: 1,
            borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Grid item xs={1}>
            <FormLabel
               sx={{ 
                mr: 4 // 왼쪽 여백이 필요할 경우
              }}
            >참고사항</FormLabel>
          </Grid>
          <Grid item xs={11}>
            <TextField
              size="small"
              variant="outlined"
              fullWidth
              id="partnerDesc"
              name="partnerDesc"
              multiline
              rows={3}
              value={formik.values.partnerDesc}
              onChange={formik.handleChange}
              error={
                formik.touched.partnerDesc && Boolean(formik.errors.partnerDesc)
              }
              helperText={
                formik.touched.partnerDesc && formik.errors.partnerDesc
              }
            />
          </Grid>
        </Grid>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mt: 2,
          }}
        >
          <Button
            type="submit"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>          
        </Box>
      </Box>
    </div>
  );
};

export default PartnerForm;
